import * as React from 'react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import * as css from './TeamDetails.scss';
import { connect, ConnectedProps } from 'react-redux';
import { showModal } from '../../redux/actions/activeModal.actions';
import { ModalName } from '../../types/ModalNames';
import { getTeamMembersList } from '../../redux/selectors/teamMembers';
import { getPermission } from '../../redux/selectors/teamDetails';
import { ModalButton, TeamCount, TeamImage, TeamName } from './TeamDetailsHelpers';
import { getTeamImageFullUrlForTableHeader, getTeamName } from '../../redux/selectors/teamDetails';
import { reportOpenEditTeamDetailsModal } from '../../redux/actions/bi.actions';
import { PermissionKey } from '../../services/server-types';
import { withExperiments, InjectedExperimentsProps } from '@wix/wix-experiments-react';
import { State } from '../../redux/configure-store';

interface IAppProps extends InjectedTranslateProps, InjectedExperimentsProps, ConnectedProps<typeof connector> {}

class TeamDetails extends React.Component<IAppProps> {

  render() {
    const { clickEdit, name, imageUrl, usersLength, invitesLength, updateProfilePermission, experiments } = this.props;

    return <div className={experiments.enabled('specs.wos.AccountTeamsTableActions') ? `${css.wrapper} ${css.tableActions}` : css.wrapper}>
      <div className={css.left}>
        <TeamImage imageUrl={imageUrl}/>
        <div className={css.details}>
          <div className={css.teamNameWrapper}>
            <TeamName name={name}/>
          </div>
          <div className={css.count}><TeamCount usersLength={usersLength} invitesLength={invitesLength}/></div>
        </div>
      </div>
      { updateProfilePermission && (<div className={css.edit}><ModalButton onClick={() => clickEdit()}/></div>) }
    </div>;
  }
}

const mapStateToProps = (state: State) => {
  const { users, invites } = getTeamMembersList(state);
  return ({
    usersLength: users.length,
    invitesLength: invites.length,
    name: getTeamName(state),
    imageUrl: getTeamImageFullUrlForTableHeader(state),
    updateProfilePermission: getPermission(state, PermissionKey.UPDATE_PROFILE),
  });
};

const connector = connect(mapStateToProps, {
  clickEdit: () => {
    reportOpenEditTeamDetailsModal();
    return showModal(ModalName.EditTeamDetails);
  }
});
export default connector(withExperiments(translate()(TeamDetails)));
